// client/src/pages/StoryDetail.js

import { useState, useEffect } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import StoryReader from '../components/stories/StoryReader.js';
import storyService from '../services/storyService.js';

export default function StoryDetail() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);

  const fromCategory = searchParams.get('from_category') || '';
  const fromSubcategory = searchParams.get('from_subcategory') || '';

  const backUrl = (() => {
    const params = new URLSearchParams();
    if (fromCategory) params.set('category', fromCategory);
    if (fromSubcategory) params.set('subcategory', fromSubcategory);
    const qs = params.toString();
    return `/stories${qs ? `?${qs}` : ''}`;
  })();

  useEffect(() => {
    storyService.getStory(slug)
      .then((d) => setStory(d.story))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div className="min-h-screen bg-cream dark:bg-bg-dark transition-colors duration-300 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-royal-300 dark:border-royal-600 border-t-gold rounded-full animate-spin" />
    </div>
  );

  if (!story) return (
    <div className="min-h-screen bg-cream dark:bg-bg-dark transition-colors duration-300">
      <div className="text-center py-20">
        <p className="text-royal-500 dark:text-royal-200 mb-4">Story not found</p>
        <Link to="/stories" className="text-royal-900 dark:text-gold hover:text-gold-dark dark:hover:text-gold-light font-medium transition-colors">Back to Stories</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-cream dark:bg-bg-dark transition-colors duration-300">
      <div className="py-8 px-4">
        <div className="max-w-2xl mx-auto mb-4">
          <Link to={backUrl} className="inline-flex items-center gap-1 text-royal-900 dark:text-gold hover:text-gold-dark dark:hover:text-gold-light text-sm font-medium transition-colors">&larr; Back to Stories</Link>
        </div>
        <StoryReader story={story} />
      </div>
    </div>
  );
}